import { deleteRequest, getRequest, postRequest, putRequest, uploadRequest, getFileRequestWithToken } from "../../apiClient";
import { UsersEndpoint } from "../../apiEndpoints";

//#region----------------- GET-----------------------
export const GetAdminUsers = async (queryString: any) => {
    var _url = UsersEndpoint.USERS_URL + (queryString ?? "");
    var res = await getRequest(_url);

    return res;
};

export const GetAdminUserById = async (id: string | number) => {
    var _url = UsersEndpoint.USER_BY_ID_URL(id);
    var res = await getRequest(_url);

    return res;
};

export const GetAdminUserProfileImageById = async (id: string | number) => {
    var _url = UsersEndpoint.USER_PROFILE_PHOTO_BY_ID_URL(id);
    var res = await getFileRequestWithToken(_url);

    return res;
};
//#endregion

//#region----------------- POST-----------------------
export const CreateAdminUserService = async (param: any) => {
    var res = await postRequest(UsersEndpoint.USERS_URL, param);

    return res;
};
//#endregion

//#region----------------- PUT-----------------------
export const EditAdminUserService = async (id: string | number, param: any) => {
    var res = await putRequest(UsersEndpoint.USER_BY_ID_URL(id), param);

    return res;
};

export const EditAdminUserProfileService = async (id: string | number, param: any) => {
    var res = await putRequest(UsersEndpoint.USER_PROFILE_BY_ID_URL(id), param);

    return res;
};

export const ResetPasswordAdminUserService = async (id: string | number, param: any) => {
    var res = await putRequest(UsersEndpoint.USER_RESET_PASSWORD_BY_ID_URL(id), param);

    return res;
};

export const UploadProfileAdminUserService = async (id: string | number, param: any) => {
    var res = await uploadRequest(UsersEndpoint.USER_UPLOAD_PROFILE_PHOTO_BY_ID_URL(id), param);

    return res;
};
//#endregion

//#region----------------- DELETE-----------------------
export const DeleteAdminUserService = async (id: string | number, param: any) => {
    var _url = UsersEndpoint.USER_DELETE_BY_ID_URL(id);
    var res = await postRequest(_url, param);

    return res;
};

//#endregion